import PropTypes from 'prop-types';

export const ResidenceStatusWidgetPropTypes = {
  residenceUuid: PropTypes.string,
  residenceTitle: PropTypes.string,
  residenceSvgId: PropTypes.string,
  residents: PropTypes.arrayOf(PropTypes.shape({
    uuid: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  })),
  statusUuid: PropTypes.string,
  residenceStatus: PropTypes.string,
  setFetchUnitData: PropTypes.func,
  setDetailDialogData: PropTypes.func,
};

export const ResidenceStatusWidgetDefaultProps = {
  residenceUuid: null,
  residenceTitle: null,
  residenceSvgId: null,
  residents: [],
  statusUuid: null,
  residenceStatus: null,
  setFetchUnitData: () => {},
  setDetailDialogData: () => {},
};
